import { h } from 'preact'
import classNames from 'clsx'

import LinkWrapper from '../link-wrapper'

import styles from './index.module.scss'

const NavLink = ({ children, className, rel, href, ...rest }) => (
  <LinkWrapper
    href={href}
    rel={rel}
    className={classNames(
      className,
      styles['a-nav-link'],
      {
        [styles['a-nav-link--next']]: rel === 'next',
        [styles['a-nav-link--prev']]: rel === 'prev',
      },
    )}
    {...rest}>
    {children}
  </LinkWrapper>
)

export default NavLink
